
if(typeof require !== 'undefined' && typeof _ === 'undefined'){
  var _ = require('lodash');
  var moment = require('moment');
}

const ActivityDictionary = function(undefined){

  return {
    digestSent: function(stream){
      return _.filter(stream, {event:'sent'}).length;
    },

    sortAndGroupEvents: function(stream){
      var THIS = this;
      var stream = _.cloneDeep(stream);

      stream = _.groupBy(stream, function(event){
        return moment(event.created).format('YYYY-MM-DD') + event.source + event.event + event.userId;
      });

      _.each(stream, function(eventSet, i){
        stream[i] = THIS.sortEvents(eventSet);
      });

      return _.sortBy(stream, function(eventSet){ return -(moment(eventSet[0].created).format('YYYYMMDDHHmmss')); });
    },

    sortEvents: function(stream){
      return _.sortBy(stream, function(event){ return -(moment(event.created).format('YYYYMMDDHHmmss')); });
    }
  }

};

if(typeof module !== 'undefined' && module.exports){
  module.exports = new ActivityDictionary();
}else if(typeof window !== 'undefined'){
  window.ActivityDictionary = ActivityDictionary;
}
